let Environment = {
    YfethContractAddress: "0xaFfd9488c8640f0eb005992F79163bBf8D0C7ab4",
  
  };
  export default Environment;